// Barra de navegación para botones
//

import React, { useContext } from 'react'
import MenuIcon from '@mui/icons-material/Menu'
import { Link, useNavigate } from 'react-router-dom'
import { AuthContext } from '../context/AuthContext'
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  IconButton,
  Box,
} from '@mui/material'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import { Brightness4, Brightness7 } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import { useTheme } from '@mui/material/styles'

const NavBar = ({
  toggleTheme,
  themeMode,
  toggleSidebar,
  isSidebarOpen,
  showSidebarToggle,
}) => {
  const theme = useTheme()
  const { user, logout } = useContext(AuthContext)
  const navigate = useNavigate()
  const { t, i18n } = useTranslation()

  const handleLogout = () => {
    logout()
    navigate('/login')
  }

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng)
  }

  return (
    <AppBar
      position="fixed"
      sx={{
        width: '100%',
        transition: theme.transitions.create('margin', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        zIndex: theme.zIndex.drawer + 3,
      }}
    >
      <Toolbar
        sx={{
          width: '100%',
          alignItems: 'center',
          gap: 1,
          flexWrap: { xs: 'wrap', sm: 'nowrap' },
          py: { xs: 0.5, sm: 0 },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            minWidth: 0,
            flex: 1,
            gap: 1,
          }}
        >
          {showSidebarToggle && (
            <IconButton
              edge="start"
              color="inherit"
              onClick={toggleSidebar}
              aria-label={isSidebarOpen ? 'Cerrar barra lateral' : 'Abrir barra lateral'}
              sx={{
                mr: 0.5,
                display: 'inline-flex',
                flexShrink: 0,
              }}
            >
              {isSidebarOpen ? <ChevronLeftIcon /> : <MenuIcon />}
            </IconButton>
          )}

          <Typography
            variant="h6"
            sx={{
              flexGrow: 1,
              minWidth: 0,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              fontSize: { xs: '1rem', sm: '1.25rem' },
            }}
          >
            CRM Application
          </Typography>
        </Box>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: { xs: 'flex-start', sm: 'flex-end' },
            flexWrap: 'wrap',
            gap: 0.5,
            width: { xs: '100%', sm: 'auto' },
          }}
        >
          <Button color="inherit" component={Link} to="/" size="small">
            {t('Inicio')}
          </Button>
          {user ? (
            <>
              <Button color="inherit" component={Link} to="/dashboard" size="small">
                {t('Dashboard')}
              </Button>
              <Button color="inherit" onClick={handleLogout} size="small">
                {t('Logout')}
              </Button>
            </>
          ) : (
            <>
              <Button color="inherit" component={Link} to="/login" size="small">
                {t('Iniciar sesión')}
              </Button>
              <Button color="inherit" component={Link} to="/register" size="small">
                {t('Registro')}
              </Button>
            </>
          )}
          <IconButton onClick={toggleTheme} color="inherit" size="small">
            {themeMode === 'light' ? <Brightness4 /> : <Brightness7 />}
          </IconButton>
          <Button color="inherit" onClick={() => changeLanguage('en')} size="small">
            EN
          </Button>
          <Button color="inherit" onClick={() => changeLanguage('es')} size="small">
            ES
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  )
}

export default NavBar
